import OptionalComponent from '@ui/optional-component/optional-component';
import BrandedLoadingIndicator from './components/branding/branded-loading-indicator';

const HydrateFallback = () => {
  return (
    <div className="flex-column jc-center ai-center height-100-vh">
      <OptionalComponent display delayRender={200}>
        <BrandedLoadingIndicator />
      </OptionalComponent>
    </div>
  );
};

export default HydrateFallback;
